import React from 'react';
import { useVerifyBubbleStoreLogin } from '@hooks/user.hook';
import ContainerBlur from '@components/navigation/ContainerBlur';
import { NumberToFormattedString } from '@utils/helpers/formatNumber';
import { Button } from 'geniebook-ui/dist';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from '@fortawesome/free-solid-svg-icons/faCartShopping';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import BubbleDropdownIcon from '@assets/icons/bubble-dropdown-icon';
import { useSetAtom, useAtomValue } from 'jotai';
import { showUnlockTrialPopUpAtom } from '@atom/popUpAtom';
import globalStore from '@store/globalStore';
import { haveSubjectForTrialAtom } from '@atom/globalQueryAtom';

export interface BubbleDropdownProps {
  earned: number;
  spent: number;
  closeDropdown: () => void;
}

const BubbleDropdown = (props: BubbleDropdownProps) => {
  const queryBubbleStoreLogin = useVerifyBubbleStoreLogin();
  const setUnlockTrialPopUp = useSetAtom(showUnlockTrialPopUpAtom, {
    store: globalStore,
  });
  const haveSubjectForTrial = useAtomValue(haveSubjectForTrialAtom);

  const handleButtonClick = async () => {
    await queryBubbleStoreLogin.mutateAsync();
  };

  return (
    <ContainerBlur
      clickaway={props.closeDropdown}
      className={haveSubjectForTrial ? '' : 'pb-4'}
    >
      <div className={'w-max ' + (haveSubjectForTrial ? 'mb-4' : '')}>
        <p
          className={'text-sm font-bold leading-4 mb-3.5 text-primary-navyblue'}
        >
          Balance
        </p>
        <div className={'flex text-sm leading-4 text-neutral-pencil mb-3'}>
          <div className={'flex-auto'}>Earned</div>
          <div className={'flex-initial'} data-testid={'earned-bubble'}>
            {NumberToFormattedString(props.earned)}
          </div>
        </div>
        <div className={'flex text-sm leading-4 text-neutral-pencil mb-5'}>
          <div className={'flex-auto'}>Spent</div>
          <div className={'flex-initial'} data-testid={'spent-bubble'}>
            {props.spent == 0
              ? '0'
              : '-' + NumberToFormattedString(props.spent)}
          </div>
        </div>
        <div>
          <Button
            className={'text-white !font-black !text-sm px-4 !h-9'}
            onClick={handleButtonClick}
          >
            <FontAwesomeIcon
              icon={faCartShopping}
              className={'text-white w-[18px] h-4'}
            />
            &nbsp;Visit Bubble Store
          </Button>
        </div>
      </div>
      {/* change url bg image later */}
      {haveSubjectForTrial && (
        <div
          className={
            'inherit-w relative pt-4 bg-[#D4F2FF] first-letter: -mx-6 px-6 pb-6 rounded-b-2xl'
          }
        >
          <div className="absolute right-0 top-0">
            <BubbleDropdownIcon className="h-[157px] w-[122px] fill-[#D4F2FF]" />
          </div>
          <p
            className={
              'relative text-sm font-bold leading-4 mb-3.5 text-primary-navyblue z-10'
            }
          >
            Need extra Bubbles?
          </p>
          <div
            className={
              'relative flex text-sm leading-4 text-neutral-pencil mb-4 break-words'
            }
          >
            Purchase an additional subject plan to enjoy more rewards.
          </div>
          <div>
            <Button
              variant={'primary-azure'}
              className={'text-white !font-black !text-sm px-4 !h-9'}
              onClick={() => setUnlockTrialPopUp(true)}
            >
              <FontAwesomeIcon
                icon={faLock}
                className={'text-white w-[18px] h-4'}
              />
              &nbsp; Unlock free trial
            </Button>
          </div>
        </div>
      )}
    </ContainerBlur>
  );
};

export default BubbleDropdown;
